import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { SortArrows } from '@rio-cloud/rio-uikit';

interface Column {
  key: string;
  label: string;
  sortable?: boolean;
  width?: string;
}

interface ColumnsProps {
  columns: Column[];
  sortBy: string;
  sortDir: 'asc' | 'desc';
  onSort: (key: string) => void;
}

const Columns: React.FC<ColumnsProps> = ({ columns, sortBy, sortDir, onSort }) => {
  const handleSort = (key: string, sortable?: boolean) => {
    if (sortable !== false) {
      onSort(key);
    }
  };

  const renderColumn = ({ key, label, sortable, width = 'w-1/5' }: Column) => (
    <th
      key={key}
      className={classNames(
        'p-3 overflow-hidden text-ellipsis whitespace-nowrap text-left user-select-none sort-column',
        width,
        {
          'cursor-pointer': sortable !== false,
        }
      )}
      onClick={() => handleSort(key, sortable)}
      title={sortable === false ? undefined : 'Clique para ordenar'}
    >
      <span className="flex items-center">
        {sortable !== false && (
          <SortArrows direction={sortBy === key ? sortDir : undefined} />
        )}
        <span className="ml-1 text-sm font-light">{label}</span>
      </span>
    </th>
  );

  return (
    <tr className="bg-[#f5f7fa] text-left">
      {columns.map(renderColumn)}
    </tr>
  );
};

export default memo(Columns);